import * as THREE from 'three';
import { OBB } from 'three/examples/jsm/math/OBB.js';

const bbox = /* @__PURE__ */ new THREE.Box3();
const v1 = /* @__PURE__ */ new THREE.Vector3();
const v2 = /* @__PURE__ */ new THREE.Vector3();
const mat4 = /* @__PURE__ */ new THREE.Matrix4();

/**
 * Given an object and a rotation, this function computes the oriented bounding box (OBB) of the object.
 * @param object
 * @param rotation
 * @returns
 */
export const getOrientedBoundingBox = (
  object: THREE.Object3D,
  rotation: THREE.Quaternion = new THREE.Quaternion(),
): OBB => {
  const obb = new OBB();
  const inverseRotation = rotation.clone().invert();

  const tempScene = object.clone(true);
  tempScene.matrix.makeRotationFromQuaternion(inverseRotation);
  tempScene.matrixAutoUpdate = false;
  tempScene.updateMatrixWorld(true);

  const box = bbox.setFromObject(tempScene, true);
  const size = box.getSize(v1);
  const center = box.getCenter(v2);

  obb.center.copy(center.applyQuaternion(rotation));
  obb.halfSize.copy(size).multiplyScalar(0.5);
  obb.rotation.setFromMatrix4(mat4.makeRotationFromQuaternion(rotation));

  return obb;
};

/*

    const inverseRotation = rotation.clone().invert();

    const tempScene = scene.clone(true);
    tempScene.matrix.makeRotationFromQuaternion(inverseRotation);
    tempScene.matrixAutoUpdate = false;
    tempScene.updateMatrixWorld(true);

    const alignedBox = new THREE.Box3().setFromObject(tempScene, true);
    const size = alignedBox.getSize(new THREE.Vector3());
    const center = alignedBox.getCenter(new THREE.Vector3());

    obb.center.copy(center.applyQuaternion(rotation));
    obb.halfSize.copy(size).multiplyScalar(0.5);
    obb.rotation.setFromMatrix4(new THREE.Matrix4().makeRotationFromQuaternion(rotation));

    return obb;*/
